export { default } from "./FeaturedContentBlock";
